import request from "@/utils/request";
const apiPath = "/meet/meeting";
import { downloadBlob } from "@/utils/download";
const meetingApi = {
  /**
   * 新增【会议】
   */
  create(data) {
    return request.post(apiPath + "/tee/save", data);
  },
  /**
   * 修改【会议】
   */
  update(data) {
    return request.put(apiPath + "/tee/update", data);
  },
  cancelMeeting(data) {
    return request.put(apiPath + "/tee/cancel", data);
  },
  /**
   * 分页查询【会议】
   */
  fetchList(query) {
    return request.get(apiPath + "/tee/list", { params: query });
  },
  fetchListForMini(query) {
    return request.get(apiPath + "/tee/listForMini", { params: query });
  },
  /**
   * 查询【会议】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query });
  },
  /**
   * 查看【会议】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`);
  },
  /**
   * 查看【会议】详情（TEE接口）
   */
  fetchByIdTee(id) {
    return request.get(`${apiPath}/tee/${id}`);
  },
  /**
   * 删除单个【会议】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`);
  },
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids });
  },
  exportExcel(query) {
    return request
      .get(`${apiPath}/export`, { responseType: "blob", params: query })
      .then(res => downloadBlob(res, "会议列表.xlsx"));
  },
  /**
   * 开启设备签到（POST body 为 raw meetingId，Content-Type: application/json，与 syncToDXIOT 一致）
   */
  openDeviceSignIn(meetingId) {
    return request.post(`${apiPath}/tee/openDeviceSignIn`, meetingId, {
      headers: { "Content-Type": "application/json" }
    });
  },
  /**
   * 关闭设备签到（POST body 为 raw meetingId，Content-Type: application/json，与 syncToDXIOT 一致）
   */
  closeDeviceSignIn(meetingId) {
    return request.post(`${apiPath}/tee/closeDeviceSignIn`, meetingId, {
      headers: { "Content-Type": "application/json" }
    });
  },
  /**
   * 同步会议名称至DXIOT（POST，Content-Type: application/x-www-form-urlencoded）
   */
  syncToDXIOT(meetingId) {
    return request.post(`${apiPath}/tee/syncToDXIOT`, meetingId, {
      headers: { "Content-Type": "application/json" }
    });
  }
};
export default meetingApi;
